import { render, staticRenderFns } from "./PinturaSidebar.vue?vue&type=template&id=4eff34fe&scoped=true"
import script from "./PinturaSidebar.vue?vue&type=script&lang=ts"
export * from "./PinturaSidebar.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PinturaSidebar.vue?vue&type=style&index=0&id=4eff34fe&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./PinturaSidebar.vue?vue&type=style&index=1&id=4eff34fe&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)
var style2 = require("./PinturaSidebar.vue?vue&type=style&index=2&id=4eff34fe&prod&lang=css")
if (style2.__inject__) style2.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4eff34fe",
  null
  ,true
)

export default component.exports